import React from "react";
import { Tab } from "@headlessui/react";
import UploadStatusReport from "./UploadStatusReport";
import StatusReportPending from "./StatusReportPending";
import StatusReportHistory from "./StatusReportHistory";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const StatusReportTabs = () => {
  return (
    <div className="w-full flex flex-col items-center justify-start mt-28">
      <Tab.Group>
        <Tab.List className="flex space-x-1 rounded-xl border-black border p-1 w-96 h-12">
          {["Apply", "Pending", "History"].map((tab) => (
            <Tab
              key={tab}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                  selected
                    ? "bg-blue-500 shadow text-white"
                    : "hover:bg-blue-100 hover:text-blue-700"
                )
              }
            >
              {tab}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="w-3/4 rounded-xl bg-white border border-black my-10">
          <Tab.Panel className="h-full">
            <UploadStatusReport />
          </Tab.Panel>
          <Tab.Panel>
            <StatusReportPending />
          </Tab.Panel>
          <Tab.Panel>
            <StatusReportHistory />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default StatusReportTabs;
